import { V3, V3O } from '../vectors/v3';

export const applyAcceleration = (velocity: V3, acceleration: V3, timeStep: number): V3 => {
  const step = V3O.scale(acceleration, timeStep);
  return V3O.add(velocity, step);
};
